import { render } from "./PlansView.vue?vue&type=template&id=671f5e9c&scoped=true"
import script from "./PlansView.vue?vue&type=script&lang=js"
export * from "./PlansView.vue?vue&type=script&lang=js"

import "./PlansView.vue?vue&type=style&index=0&id=671f5e9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671f5e9c"]])

export default __exports__